<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>控股集团官网</el-breadcrumb-item>
      <el-breadcrumb-item>产品沿革</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入产品名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Listorder" label="排序" min-width="5%"></el-table-column>
          <el-table-column prop="Name" label="产品名称" min-width="15%"></el-table-column>
          <el-table-column prop="Content" label="产品简介" min-width="35%"></el-table-column>
          <el-table-column prop="Pic" label="产品图片" min-width="35%"></el-table-column>
          <el-table-column label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加">
        <el-form :model="addData" ref="addDataRef" label-width="110px">
          <el-form-item label="产品名称" class="addAdminForm">
            <el-input v-model="addData.name" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="产品简介" class="addAdminForm">
            <el-input v-model="addData.content" placeholder="请输入产品简介"></el-input>
          </el-form-item>
          <el-form-item label="产品图片" class="addAdminForm">
            <el-input v-model="addData.pic" type="textarea" :rows="5" placeholder="请输入产品图片"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="BackToFirst">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <KgjtWebsiteProductEvolutionEdit ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></KgjtWebsiteProductEvolutionEdit>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import KgjtWebsiteProductEvolutionEdit from '@/componentsKgjt/KgjtWebsiteProductEvolutionEdit.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    KgjtWebsiteProductEvolutionEdit
  },
  name: 'MyKgjtWebsiteProductEvolution',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      isList: [
        { value: '1', label: '是' },
        { value: '0', label: '否' }
      ],
      // 查询客户
      keywords: {
        name: ''
      },
      // 添加
      addData: {
        name: '',
        content: '',
        pic: ''
      }
    }
  },
  mounted () {
    this.GetKgjtWebsiteProductEvolutionNum()
    this.GetKgjtWebsiteProductEvolutionList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.GetKgjtWebsiteProductEvolutionList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteProductEvolutionList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetKgjtWebsiteProductEvolutionNum()
      this.GetKgjtWebsiteProductEvolutionList()
    },
    clickadd () {
      this.AddKgjtWebsiteProductEvolution()
    },
    // 修改
    goEdit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    // 删除
    goDel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteProductEvolution(row)
      })
    },
    GetKgjtWebsiteProductEvolutionList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteProductEvolutionList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteProductEvolutionNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteProductEvolutionNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteProductEvolution: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.addData.name,
        content: that.addData.content,
        pic: that.addData.pic
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteProductEvolution, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.name = ''
            that.addData.content = ''
            that.addData.pic = ''

            that.GetKgjtWebsiteProductEvolutionNum()
            that.GetKgjtWebsiteProductEvolutionList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteProductEvolution: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteProductEvolution, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteProductEvolutionNum()
          that.GetKgjtWebsiteProductEvolutionList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
